module.exports = __webpack_public_path__ + "img/arrow-red.dece4f0a.svg";